import { Component, OnInit } from '@angular/core';
import {Router} from "@angular/router";
import {Location} from "@angular/common";

@Component({
  selector: 'app-lateral-entry-migration',
  templateUrl: './lateral-entry-migration.component.html',
  styleUrls: ['./lateral-entry-migration.component.scss']
})
export class LateralEntryMigrationComponent implements OnInit {

    currentPath: string;

    constructor(private router: Router,
                private location: Location) {
        this.currentPath = this.location.path();
    }

    isActive(path: string): boolean {
        return this.currentPath === path;
    }

  ngOnInit(): void {
  }

    goTo(url:any){
      this.router.navigateByUrl(url);
    }

}
